import React, { useState } from 'react';
import frame from '../../../assets/images/Union.svg';
import spring from '../../../assets/images/spring.png';
import ImagePaging from './image-slider';
import VideoPaging from './video-slider';
import ProductItems from './product-slider';
import defaultAvatar from '../../../assets/images/default-avatar.jpg';
import {
  TickOneIcon,
  OneFacebookIcon,
  OneInstagramIcon,
  OneTikTokIcon,
} from '../../atoms/icons';

export const TemplateFive = ({
  expertiseData,
  preferredBrands,
  preferredProducts,
  redirectToBuyerPortal,
  redirectToShopPortal,
  cardDetails,
  schedulerEnabled,
}) => {
  const { seller, storefront } = cardDetails?.current?.config;
  const LogoUrl =
    storefront?.general?.longLogoImage?.url ||
    storefront?.general?.logoImage?.url ||
    null;

  const [isExpanded, setIsExpanded] = useState(false);
  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <div className="four-wrapper five-wrapper">
        <header>
          <section className="flex justify-between items-center gap-6 head-sec  px-4 py-2.5">
            {LogoUrl ? (
              <div className="logo-box max-w-56">
                <img src={LogoUrl} alt="logo" />
              </div>
            ) : (
              <h2 className="logo-text pl-1 text-fivePrimary capitalize">
                {storefront?.general?.name}
              </h2>
            )}
          </section>
          <div className="top-sec md:flex-row  flex-col-reverse relative">
            <img src={spring} className="spring" />
            <div className="md:min-w-fit min-w-full">
              <div className="mobile-view">
                <h2 className="text-white-main font-bold lg:text-5xl text-4xl font-tempOne capitalize break-words">
                  {seller?.profile?.title}
                </h2>

                <div className="long-text">
                  <div
                    className={
                      isExpanded
                        ? 'full-text'
                        : seller?.profile?.about?.length > 600
                        ? 'clamped-text'
                        : ''
                    }
                  >
                    <p
                      className="font-normal text-xl mt-5 font-tempOne after:border-twoPrimary text-white-main mb-6 break-words"
                      dangerouslySetInnerHTML={{
                        __html: seller?.profile?.about,
                      }}
                    />
                  </div>
                  {seller?.profile?.about?.length > 600 && (
                    <div className="text-right">
                      <button
                        className="text-fivePrimary read-text"
                        onClick={toggleReadMore}
                      >
                        {isExpanded ? 'Read Less' : 'Read More'}
                      </button>
                    </div>
                  )}
                </div>
                <div className="flex gap-4  items-center mt-5">
                  {seller?.profile?.facebookUrl && (
                    <a
                      href={seller?.profile?.facebookUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cursor-pointer"
                    >
                      <OneFacebookIcon className="text-fivePrimary" />
                    </a>
                  )}
                  {seller?.profile?.instagramUrl && (
                    <a
                      href={seller?.profile?.instagramUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cursor-pointer"
                    >
                      <OneInstagramIcon className="text-fivePrimary" />
                    </a>
                  )}
                  {seller?.profile?.tiktokUrl && (
                    <a
                      href={seller?.profile?.tiktokUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cursor-pointer"
                    >
                      <OneTikTokIcon className="text-fivePrimary" />
                    </a>
                  )}
                </div>
                <button
                  className="text-white-main font-normal md:w-auto w-full text-xl mt-10 md:px-10 px-4 py-5 rounded-FiveCustom bg-fivePrimary button-shadow"
                  onClick={() =>
                    redirectToShopPortal(storefront?.general?.shopUrl)
                  }
                >
                  Shop the store
                </button>
              </div>
            </div>
            <div className="relative cover-box">
              <div className=" image-box">
                <img
                  src={
                    seller?.profile?.avatar?.mediumUrl ||
                    seller?.profile?.avatar?.url ||
                    defaultAvatar
                  }
                  alt="icon"
                  className="relative z-10 profilebg"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = defaultAvatar;
                  }}
                />
              </div>
              <img src={frame} alt="frame" className=" absolute  frame1" />
            </div>
          </div>
        </header>
        <section className="four-body">
          <div className="four-Inner-body">
            {seller?.profile?.galleryImages?.length ? (
              <div className="md:mt-10 md:mx-0 -mx-4 imageSlider-box">
                <h2 className=" text-center font-normal md:text-4xl text-2xl font-tempOne mt-7 mb-5 text-white-main">
                  <strong className="font-extrabold">Salon Gallery</strong>
                </h2>
                <ImagePaging images={seller?.profile?.galleryImages} />
              </div>
            ) : (
              <></>
            )}
            {seller?.profile?.galleryVideoLinks?.length ? (
              <>
                <div className="md:mt-10 mt-18 mb-18 md:mb-0 md:mx-0 -mx-4 imageSlider-box">
                  <h2 className=" text-center font-normal md:text-4xl text-2xl font-tempOne mt-7 mb-5 text-white-main">
                    <strong className="font-extrabold">Salon Videos</strong>
                  </h2>
                  <VideoPaging videos={seller?.profile?.galleryVideoLinks} />
                </div>
              </>
            ) : (
              <></>
            )}
            <div>
              {expertiseData?.length !== 0 ? (
                <div
                  className={
                    expertiseData?.length === 0
                      ? 'visibility-hidden'
                      : 'visibility-auto'
                  }
                >
                  <div className="Expertise-box-wrp text-center ">
                    <h2 className="text-white-main font-semibold md:text-4xl text-2xl font-tempOne md:mt-7 mt-14 mb-7">
                      Expertise
                    </h2>
                    <ul className="grid md:gap-8 gap-4  four-list">
                      {expertiseData?.map((item, index) => (
                        <li key={index}>
                          <TickOneIcon className="text-fivePrimary" />
                          <span className="ml-2.5 font-normal text-base">
                            {item?.name}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ) : (
                <div
                  className={
                    seller?.profile?.expertise
                      ? 'visibility-auto'
                      : 'visibility-hidden'
                  }
                >
                  <div className="Expertise-box-wrp text-center ">
                    <h2 className="text-white-main font-semibold md:text-4xl text-2xl font-tempOne md:mt-7 mt-14 mb-7">
                      Expertise
                    </h2>
                    <p
                      className="mt-5 font-tempOne border-onePrimary text-base  text-white-main"
                      dangerouslySetInnerHTML={{
                        __html: seller?.profile?.expertise,
                      }}
                    />
                  </div>
                </div>
              )}
              {schedulerEnabled && (
                <div className="text-center mt-6">
                  <button
                    className="text-white-main font-normal md:w-auto w-full text-xl md:px-10 px-4 py-5 rounded-FiveCustom bg-fivePrimary button-shadow"
                    onClick={() => redirectToBuyerPortal()}
                  >
                    Book an appointment
                  </button>
                </div>
              )}
            </div>
            <div className="md:mt-10 mt-14 text-center">
              {preferredProducts?.length ? (
                <div
                  className={
                    preferredProducts?.length === 0
                      ? 'visibility-hidden'
                      : 'visibility-auto'
                  }
                >
                  <h2 className=" text-center font-normal md:text-4xl text-2xl font-tempOne mt-7 mb-5 text-white-main">
                    <strong className="font-extrabold">
                      My Favorite Products
                    </strong>
                  </h2>
                  <ProductItems
                    preferredProducts={preferredProducts}
                    storefront={storefront}
                  />
                </div>
              ) : preferredBrands?.length ? (
                <div
                  className={
                    preferredBrands?.length === 0
                      ? 'visibility-hidden'
                      : 'visibility-auto'
                  }
                >
                  <h2 className=" text-center font-normal md:text-4xl text-2xl font-tempOne mt-7 mb-5 text-white-main">
                    <strong className="font-extrabold">
                      My Favorite Brands
                    </strong>
                  </h2>
                  <ProductItems
                    preferredBrands={preferredBrands}
                    storefront={storefront}
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
